import {
	ResourceCard as BlogCard,
	type ResourceCardProps as BlogCardProps,
} from '@hashicorp/react-components/src/components/card/resource-card'
import BlogsLayout from 'layouts/blogs'
import { formatDateStyleMedium } from 'lib/formatting/date-time'
import FacetedSearchPage from 'views/faceted-search'
import FeaturedSection from 'views/blog/components/featured-section'
import type { Products } from '@hashicorp/platform-product-meta'
import type { InferGetServerSidePropsType } from 'next'
import { getServerSideProps } from './server'
import s from './style.module.css'

function BlogAllPage({
	serverState,
	serverUrl,
	hero,
	paginationType,
	metaTags,
	featuredBlog,
}: InferGetServerSidePropsType<typeof getServerSideProps>): JSX.Element {
	return (
		<FacetedSearchPage
			contentType="blog"
			contentLabel="post"
			metaTags={metaTags}
			hero={{ ...hero, className: featuredBlog && s.hero }}
			paginationType={paginationType}
			panel={{
				searchBox: { label: 'Search for posts by title' },
				fieldSets: [
					{ heading: 'Product', attribute: 'products', inputType: 'checkbox' },
					{ heading: 'Category', attribute: 'category', inputType: 'checkbox' },
				],
			}}
			transformItems={(items) => items.map((item) => formatBlog(item))}
			serverState={serverState}
			serverUrl={serverUrl}
			hitComponent={BlogCard}
		>
			{featuredBlog && <FeaturedSection {...featuredBlog} />}
		</FacetedSearchPage>
	)
}

BlogAllPage.layout = BlogsLayout

export default BlogAllPage

function formatBlog(blog) {
	const { title, slug, orderingDate, products, category, photoUrl, photoAlt } =
		blog

	const link = `/blog/${slug}`

	const productBadges: Array<Products> = products.map((product) =>
		product.toLowerCase()
	)

	const date =
		orderingDate && typeof orderingDate === 'string'
			? formatDateStyleMedium(orderingDate)
			: null

	const props: BlogCardProps = {
		date,
		heading: title,
		thumbnail: {
			src:
				photoUrl ||
				'https://www.datocms-assets.com/2885/1599944275-blog-share-card.png',
			alt: photoAlt || '', // Decorative element in most cases
		},
		category: category,
		link,
		productBadges,
	}

	return {
		...blog,
		...props,
	}
}
